
const ApplicationStatus = {
  Draft: { value: "DRAFT", label: "Draft" },
  Submitted: { value: "SUBMITTED", label: "Submitted" },
  UnderReview: { value: "UNDER_REVIEW", label: "Under review" },
  Approved: { value: "APPROVED", label: "Approved" },
  Declined: { value: "DECLINED", label: "Declined" },
  ProjectStarted: { value: "PROJECT_STARTED", label: "Project started" },
  Deferred: { value: "DEFERRED", label: "Deferred" },
  Archived: { value: "ARCHIVED", label: "Archived" },
};
const applicationStatusByValue = new Map<string, typeof ApplicationStatus[keyof typeof ApplicationStatus]>(
    Object.values(ApplicationStatus).map((entry) => [entry.value, entry])
);

const ProjectStatus = {
  Underway: {value: "UNDERWAY", label: "Underway"},
  ChangeReview: {value: "CHANGE_REVIEW", label: "Change review"},
  Completed: {value: "COMPLETED", label: "Completed"},
  Lapsed: {value: "LAPSED", label: "Lapsed"},
  Discontinued: {value: "DISCONTINUED", label: "Discontinued"}
};
const projectStatusByValue = new Map<string, typeof ProjectStatus[keyof typeof ProjectStatus]>(
    Object.values(ProjectStatus).map((entry) => [entry.value, entry])
);

const getSummaryStatusLabel = (applicationStatus: string, projectStatus: string)  => {
  if (projectStatus && projectStatus.length > 0) {
    return projectStatusByValue.get(projectStatus)?.label;
  } else {
    return applicationStatusByValue.get(applicationStatus)?.label;
  }
}

export { ApplicationStatus, ProjectStatus, getSummaryStatusLabel }